module.exports = __webpack_public_path__ + "static/media/ic_launcher.6f8c15fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ic_launcher.png
// module id = 927
// module chunks = 0